import { put, takeLatest,select } from 'redux-saga/effects'
import {
  GET_USERINFO,
  GET_USERINFO_SUCCESSED,
  GET_USERINFO_FAILED,
  UPDATE_USERINFO,
  UPDATE_USERINFO_SUCCESSED,
  SAVE_SECURITYQUESTIONS,
  SAVE_SECURITYQUESTIONS_FAILED,
  SAVE_SECURITYQUESTIONS_SUCCESSED
} from '../actions/actionTypes'
import { ApiService } from '../services/ApiService'
import { AuthApiService } from '../services/AuthApiService'

const _authApiService = new AuthApiService()

function* fetchUserInfo(action) {
  try {

    var allquestions = yield select((state)=>state.challengeQuestionsReducers)
    let response = yield _authApiService.getUserInformation(action.params.refnum);
    if (!response || response.error) {
      yield put({
        type: GET_USERINFO_FAILED,
        message: response.error || "An error has occured"
      })
    } else {
      var emptyQuestions = false;
      if(!response.challengeQuestions){
        emptyQuestions = true;
        response.challengeQuestions = [allquestions.data.challengeQuestions[0],allquestions.data.challengeQuestions[1],allquestions.data.challengeQuestions[2]]
      }
      yield put({
        type: GET_USERINFO_SUCCESSED,
        data: Object.assign({
        }, response, { question1:response.challengeQuestions[0],question2:response.challengeQuestions[1],question3:response.challengeQuestions[2],
        answer1:null,answer2:null,answer3:null,emptyQuestions:emptyQuestions})
      })
    }
  } catch (error) {
    yield put({
      type: GET_USERINFO_FAILED,
      message: error.message
    })
  }
}

export function* watchFetchUserInfo() {
  yield takeLatest(GET_USERINFO, fetchUserInfo)
}



function* updateUserInfo(action) {
        yield put({
          type: UPDATE_USERINFO_SUCCESSED,
          data: Object.assign({
          }, {} , action.params)
        })
}
  
export function* watchUpdateUserInfo() {
    yield takeLatest(UPDATE_USERINFO, updateUserInfo)
}

function* saveSecurityQuestions(action) {
  try {
    let payload = {challengeQuestions:[
      {name:action.params.question1,value:action.params.answer1},
      {name:action.params.question2,value:action.params.answer2},
      {name:action.params.question3,value:action.params.answer3}
    ]}
    let response = yield _authApiService.updateQuestion(action.params.refnum,payload)
    if (!response || response.error) {
      yield put({
        type: SAVE_SECURITYQUESTIONS_FAILED,
        message: response.error || "An error has occured"
      })
    } else {
      yield put({
        type: SAVE_SECURITYQUESTIONS_SUCCESSED,
        data: Object.assign({
        }, action.params,response)
      })
    }
  } catch (error) {
    yield put({
      type: SAVE_SECURITYQUESTIONS_FAILED,
      message: error.message
    })
  }
}

export function* watchSaveSecurityQuestions() {
  yield takeLatest(SAVE_SECURITYQUESTIONS, saveSecurityQuestions)
}